// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ActionBar from '../../layout/ActionBar';
import AddKeyPoolNotification from './slideout/AddKeyPoolNotification';
import { getAllWorkflows } from '../../../actions/workflowActions';
import { getKeyProviders } from '../../../actions/keyProviderActions';
import { getPlatforms } from '../../../actions/platformActions';
import KeyPoolNotificationsList from './components/KeyPoolNotificationsList';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { fetchAllGames } from '../../../reducers/gameReducer';

function KeyPoolNotifications({
  workflows,
  getAllWorkflows,
  keyProviders,
  getKeyProviders,
  platforms,
  getPlatforms,
}) {
  usePageTitle(['Key pool notifications', 'Settings']);

  const games = useAppSelector((state) => state.games);
  const currentUser = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const [reload, setReload] = useState<Date | undefined>();
  const { t } = useTranslation();

  useEffect(() => {
    if (!workflows) {
      getAllWorkflows();
    }
  }, [workflows, getAllWorkflows]);

  useEffect(() => {
    if (!keyProviders) {
      getKeyProviders();
    }
  }, [keyProviders, getKeyProviders]);

  useEffect(() => {
    if (!platforms) {
      getPlatforms();
    }
  }, [platforms, getPlatforms]);

  useEffect(() => {
    if (!games) {
      dispatch(fetchAllGames());
    }
  }, [dispatch, games]);

  const [addSlideoutOpen, setAddSlideoutOpen] = useState(false);
  const addKeyPoolNotification = (e) => {
    e.cancelBubble = true;
    setAddSlideoutOpen(true);
    return false;
  };

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={addKeyPoolNotification}
          text={t('Add key pool notification')}
          testId="add-key-pool-notification-button"
        />
      </ActionBar>

      <KeyPoolNotificationsList reload={reload} currentUser={currentUser} />

      <SlidingPane
        isOpen={addSlideoutOpen}
        hideHeader={true}
        from="right"
        className="large-side-panel"
        onRequestClose={() => setAddSlideoutOpen(false)}
      >
        <>
          {games && workflows && keyProviders && platforms && (
            <AddKeyPoolNotification
              games={games}
              workflows={workflows}
              keyProviders={keyProviders}
              platforms={platforms}
              cancel={() => setAddSlideoutOpen(false)}
              done={(d) => {
                setReload(new Date());
                setAddSlideoutOpen(false);
              }}
            />
          )}
        </>
      </SlidingPane>
    </>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    workflows: state.workflows,
    keyProviders: state.keyProviders,
    platforms: state.platforms,
  };
}

const mapDispatchToProps = {
  getAllWorkflows,
  getKeyProviders,
  getPlatforms,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KeyPoolNotifications);
